<template>
  <div class="row">
    <div v-if="information.hasRelateSie" class="related-sie-container mb-3">
      <icon-view
        class="mr-2 mt-3 rounded-circle icon-view-color-text"
        icon="fas fa-info mb-1"
        icon-background="white"
        icon-color="#FF7058"
        icon-size="16px"
        title="Información de SIE Relacionado"
        :gradient="true"
      />
      <div class="container row ml-3 mt-4">
        <span class="data-title d-block col-12"> Número de SIE: </span>
        <span class="color-black font-16 col-12">
          {{ information.studentSieId | empty }}
        </span>
      </div>
    </div>
    <div
      v-if="canRelatedSie && !information.hasRelateSie"
      class="col-12 row relate-sie-container bg-light custom-rounded p-4 ml-1"
    >
      <validation-observer
        ref="relateStudentFromPublicPotalForm"
        class="col-12"
      >
        <icon-view
          class="rounded-circle icon-view-color-text"
          icon="fas fa-user-tag mb-1"
          icon-background="white"
          icon-color="#FF7058"
          icon-size="16px"
          title="Relacionar SIE"
        />
        <span class="data-title d-block mt-3">Número de SIE:</span>
        <validation-provider
          v-slot="{ errors }"
          rules="required|studentSie"
          name="relatedStudentFromPublicPortal"
          class="row pb-3"
          :custom-messages="{
            required: 'El número de SIE es requerido.',
            studentSie: 'El número de SIE no es correcto.'
          }"
        >
          <div class="related-sie-wrapper col-3 row">
            <custom-input
              id="related-sie-public-portal-input"
              v-model.trim="relatedStudentSie"
              type="tel"
              placeholder="Escriba número de SIE"
              class="col-12"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              maxlength="8"
            />
          </div>
          <div class="d-flex align-items-start col">
            <action-button
              id="relate-student-public-portal-button"
              i="fa fa-user-friends"
              variant="success"
              @click="handleRelatedStudent"
            >
              Relacionar</action-button
            >
            <action-button
              id="clear-related-student-public-portal-button"
              i="fa fa-times-circle"
              v-show="relatedStudentSie"
              variant="outline-danger"
              class="ml-3"
              @click="clearRelateSieValidation"
              >Cancelar</action-button
            >
          </div>
        </validation-provider>
      </validation-observer>
      <div v-if="information.studentSieId" class="w-100">
        <div class="col-12 panel-yellow">
          <i class="fas fa-bell-exclamation icon" />
          <p class="content">
            Se identificó que el número de SIE [<span
              class="font-weight-bold"
              >{{ information.studentSieId }}</span
            >] fue provisto por el padre, madre y/o encargado. Si es el
            correcto, favor relacionar el SIE al estudiante.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IconView from "icon-view";
import CustomInput from "CustomInput";
import ActionButton from "ActionButton";
import StudentServices from "@/services/student";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin";
import store from "@/store/index";

export default {
  name: "RelateNumberSie",
  mixins: [alertMixin],
  components: {
    IconView,
    CustomInput,
    ActionButton
  },
  props: {
    information: {
      type: Object,
      default: null
    },
    relateSie: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      regOnlineStudentId: 0,
      relatedStudentSie: null
    };
  },
  computed: {
    canRelatedSie() {
      return this.userHasPermissions("student.referralregonline.relatedsie");
    }
  },
  async mounted() {
    this.regOnlineStudentId = Number(this.$route.params.registrationId);
  },
  methods: {
    async handleRelatedStudent() {
      const isValid = await this.$refs.relateStudentFromPublicPotalForm.validate();

      if (!isValid) return;

      const payload = {
        regOnlineStudentId: this.regOnlineStudentId,
        eduespSie: this.relatedStudentSie
      };

      let message = "";
      let canSubmit = false;

      await StudentServices.validateReferralStudentFromPublicPortal(payload)
        .then(r => {
          message = `¿Está seguro(a) que desea relacionar el número de SIE ${this.relatedStudentSie} al estudiante ${this.information.firstName} ${this.information.lastMaternalName} ${this.information.lastPaternalName}?`;
          if (!r.data.status) {
            message = r.data.message;
          }

          canSubmit = true;
        })
        .catch(error => {
          this.ShowToast("Alerta", error.response.data.message, "error");
        });

      if (canSubmit) {
        const answer = await this.ShowCancelModal("Relacionar SIE", message);

        if (!answer) return;

        await StudentServices.relateReferralStudentFromPublicPortal({
          ...payload,
          eduespSie: parseInt(payload.eduespSie),
          academicYear: this.information.academicYearId,
          month: this.information.month
        })
          .then(async ({ data }) => {
            if (data) {
              this.ShowToast(
                "Proceso Existoso",
                "El número de SIE ha sido relacionado al estudiante seleccionado exitosamente.",
                "success"
              );
              this.$emit("reload-info");
            }
          })
          .catch(err =>
            this.ShowToast(
              "",
              err.message || err.response.data.message,
              "error"
            )
          );
      }
    },
    async clearRelateSieValidation() {
      this.relatedStudentSie = null;
      await this.$refs.relateStudentFromPublicPotalForm.reset();
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-rounded {
  border-radius: 5px;
}

.panel-yellow .content {
  color: #af6708;
  margin-left: 12px;
  text-align: left;
}
.panel-yellow .icon {
  font-size: 22px;
  color: #af6708;
  margin-top: 3px;
}
.panel-yellow {
  display: flex;
  flex-direction: row;
  padding: 16px 25px 5px 18px;
  background: #fff5e8;
  border: 1px solid #fdac41;
  border-radius: 4px;
  margin: 3px;
}
</style>
